import moment from 'moment';
import 'moment/locale/pt';
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import starIcon from '../../../../assets/medico-online/Star.png';
import starEmptyBorder from '../../../../assets/star-empty-border.png';
import noPhotoDoctor from '../../../../assets/medico_sem_foto.png';
import {Column, Row} from '../../../../components/layout';
import * as fonts from '../../../../util/fonts';
import {strings} from '../../../../util/strings';
import AppointmentDetails from '../../../appointment-details';
import AppointmentWarningPopup from '../../../appointment-warning-popup';
import './styles.scss';
import {Rating} from '@mui/material';
import CameraAppointmentConfirmedIcon from './assets/CameraAppointmentConfirmedIcon';
import {addToWizard} from '../../../../store/actions';
import {uriGetAppointment} from '../../../../api/endpoints';
import {get} from '../../../../api/api';
import colors from '../../../../util/colors';
import {useMediaQuery} from 'react-responsive';
import ModalTemplate from '../../../../components/modal';
import Header2 from '../../../../components/headers/header2';
import {
  cleanProfessionalNameFromDr,
  getColor,
  joinLanguages,
  joinSpecialities,
} from '../../../../util/utility';
import {languageReducer} from '../../../../store/reducers/mix';

export interface DoctorsListItemDayTimeProps {
  buStyles: any;
  appointmentItem: any;
  labels: typeof strings.pt.appointments;
  borderColor?: any;
  setRefresh(value: any): void;
  nextStep?: Function;
  addToWizard(value: any): void;
  setSelectedTime(value: any): void;
  selectedTime: any;
  enableMedicInfo: boolean;
  language: any;
}

function DoctorsListItemDayTime({
  appointmentItem,
  buStyles,
  labels,
  borderColor,
  setRefresh,
  nextStep,
  addToWizard,
  setSelectedTime,
  selectedTime,
  enableMedicInfo,
  language,
}: DoctorsListItemDayTimeProps) {
  const [appointmentsLabels, setAppointmentsLabels] = useState({
    ...strings.pt.appointments,
    ...labels,
  });

  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [appointmentClick, setAppointmentClick] = useState(false);
  const [showMedicInfo, setShowMedicInfo] = useState(false);
  const [appointmentStartError, setAppointmentStartError] = useState(false);
  const [seeMore, setSeeMore] = useState(false);

  const featureName = 'Appointments-DoctorsListDayTime';

  const isResponsive = useMediaQuery({maxDeviceWidth: 768});
  const customBorder = `1px solid ${borderColor}`;
  const languages = joinLanguages(appointmentItem?.languages);

  const specialties = joinSpecialities(appointmentItem?.specialties);

  const handleStartAppointment = async () => {
    try {
      await get(
        uriGetAppointment(appointmentItem.id, appointmentItem.providerId),
        false,
        0,
        featureName
      ).then((res: any) => {
        window.open(res.data.link, '_blank')?.focus();
      });
    } catch {
      setAppointmentStartError(true);
    }
  };

  const renderDate = (date: any) => {
    const appointmentDate = date && moment(date);
    moment.locale(language); // Set the locale to Portuguese

    const today = new Date();
    const isAppointmentToday = moment(appointmentDate).isSame(today, 'day');

    const tomorrow = moment(today).add(1, 'days');
    const isAppointmentTomorrow = moment(appointmentDate).isSame(
      tomorrow,
      'day'
    );

    if (!isAppointmentToday && !isAppointmentTomorrow) {
      return (
        <div className="date-container">
          <Row className="date-row1">
            <span style={{...fonts.SM, ...fonts.Bold}}>
              {moment(date).format('DD MMM')}
            </span>
          </Row>
          <Row className="date-row2">
            <span style={{...fonts.SM}}>{moment(date).format('YYYY')}</span>
          </Row>
        </div>
      );
    } else if (isAppointmentToday) {
      return (
        <span
          style={{...fonts.SM, ...fonts.Bold}}
          className="appointment-today">
          {labels?.appointments_today}
        </span>
      );
    } else if (isAppointmentTomorrow) {
      return (
        <span style={{...fonts.SM, ...fonts.Bold}}>
          {labels?.appointments_tomorrow}
        </span>
      );
    }
  };

  const loadNoPhotoDoctor = (event: any) => {
    event.target.src = noPhotoDoctor;
  };

  const renderModalAndPopups = () => {
    return (
      <>
        <AppointmentWarningPopup
          showModal={showWarningModal}
          setShowModal={setShowWarningModal}
          selectedAppointmentId={appointmentItem.id}
          selectedAppointmentProviderId={appointmentItem.providerId}
          status={appointmentItem.status}
          setRefresh={setRefresh}
          handleStartAppointment={handleStartAppointment}
        />
        <AppointmentDetails
          showDetailsModal={showDetailsModal}
          setShowDetailsModal={setShowDetailsModal}
          selectedAppointmentId={appointmentItem.id}
          selectedAppointmentProviderId={appointmentItem.providerId}
          borderColor={borderColor}
          setRefresh={setRefresh}
          handleStartAppointment={handleStartAppointment}
        />
      </>
    );
  };

  const renderDoctorInfo = () => {
    return (
      <ModalTemplate
        className="doctor-details-modal-container"
        inputType="confirm"
        show={showMedicInfo}
        onHide={() => {
          setShowMedicInfo(false);
        }}
        onCancel={() => {
          setShowMedicInfo(false);
        }}
        cross={true}
        hideFooter={true}>
        <Column className="doctor-details-container">
          <Header2
            style={{...fonts.XL, color: colors.black, fontWeight: 'bolder'}}
            className="doctor-details-container-title">
            {appointmentsLabels.appointments_doctor_details_title}
          </Header2>
        </Column>

        <div className="appointment-details-doctor-info-container appointment-linear-gradient">
          <div className="appointment-details-doctor-info">
            <img
              src={
                appointmentItem?.photo?.normal
                  ? appointmentItem?.photo?.normal
                  : noPhotoDoctor
              }
              onError={loadNoPhotoDoctor}
              className="appointment-details-doctor-image appointment-details-doctor-image-border"
              style={getColor('borderColor', borderColor)}
            />

            <div className="appointment-details-doctor-info-responsive">
              <p className="appointment-details-doctor-name">
                {cleanProfessionalNameFromDr(appointmentItem?.name)}
              </p>
              <p className="appointment-details-doctor-specialities">
                {specialties}
              </p>
              <div className="appointment-details-doctor-rating">
                <Rating
                  defaultValue={
                    parseFloat(
                      appointmentItem.rating ? appointmentItem.rating : 0
                    ) / 2
                  }
                  precision={0.01}
                  readOnly
                  icon={<img src={starIcon} width={10} />}
                  emptyIcon={<img src={starEmptyBorder} width={10} />}
                />
              </div>
            </div>
          </div>
          <div className="appointment-details-doctor-curricular-info">
            <p className="appointment-details-doctor-curricular">
              {appointmentsLabels.appointments_detail_curricular_info}
            </p>
            {languages && (
              <>
                <p className="appointment-details-doctor-languages-title">
                  {appointmentsLabels.appointments_detail_languages}
                </p>
                <p className="appointment-details-doctor-languages">
                  {languages}{' '}
                  <span>
                    {!seeMore && appointmentItem?.academicBackground && (
                      <a
                        className="appointment-slot-see-more"
                        style={getColor('color')}
                        onClick={() => {
                          setSeeMore(true);
                        }}>
                        {appointmentsLabels.see_more}
                      </a>
                    )}
                  </span>
                </p>
              </>
            )}
            {seeMore && appointmentItem?.academicBackground && (
              <>
                <p className="appointment-details-doctor-academic-title">
                  {appointmentsLabels.appointments_detail_academic_background}
                </p>
                <p className="appointment-details-doctor-academic-info">
                  {appointmentItem?.academicBackground}
                  <span>
                    {seeMore && (
                      <a
                        className="appointment-slot-see-more"
                        style={getColor('color')}
                        onClick={() => {
                          setSeeMore(false);
                        }}>
                        {appointmentsLabels.see_less}
                      </a>
                    )}
                  </span>
                </p>
              </>
            )}
          </div>
        </div>
      </ModalTemplate>
    );
  };

  useEffect(() => {
    if (appointmentClick) {
      addToWizard({appointmentSlot: appointmentItem});
      nextStep && nextStep();
    }
  }, [appointmentClick]);

  const renderStarIcon = () => {
    return <img src={starIcon} width={10} />;
  };

  const renderEmptyStar = () => {
    return <img src={starEmptyBorder} width={10} />;
  };

  return (
    <>
      <Row className="homepage-margin-bottom-day-time">
        <Column className="appointment-doctor-column1" style={{...fonts.MM}}>
          <img
            src={appointmentItem?.photo?.normal}
            onError={loadNoPhotoDoctor}
            className="doctor-imgs"
            style={{border: customBorder}}
          />
        </Column>
        <Column className="appointment-doctor-column2">
          {enableMedicInfo && (
            <a
              onClick={() => setShowMedicInfo(true)}
              style={{
                ...fonts.M,
                ...fonts.SemiBold,
                color: buStyles.primaryColor,
              }}>
              {cleanProfessionalNameFromDr(appointmentItem.name)}
            </a>
          )}
          {!enableMedicInfo && (
            <span
              style={{
                ...fonts.M,
                ...fonts.SemiBold,
                color: buStyles.primaryColor,
              }}>
              {cleanProfessionalNameFromDr(appointmentItem.name)}
            </span>
          )}
          <span style={{...fonts.SM}}>
            {appointmentItem.specialties[0]?.name}
          </span>
          <Rating
            className="ratings"
            defaultValue={
              parseFloat(appointmentItem.rating ? appointmentItem.rating : 0) /
              2
            }
            precision={0.01}
            readOnly
            icon={renderStarIcon()}
            emptyIcon={renderEmptyStar()}
          />
          <Row className="slots-container">
            {!isResponsive && (
              <span className="slots-available" style={{...fonts.SM}}>
                {labels?.appointments_slots_available}:
              </span>
            )}
          </Row>
        </Column>

        <Column className="day-time-list-item-column3">
          <Row className="time-doctor-list">
            <CameraAppointmentConfirmedIcon />
            {renderDate(appointmentItem.appointmentSlots[0]?.startTime)}
          </Row>
        </Column>
      </Row>
      <Row
        className={
          isResponsive
            ? 'slots-containers-row-responsive'
            : 'slots-containers-row'
        }>
        {appointmentItem.appointmentSlots?.map((item: any) => (
          <div
            onClick={() => {
              if (selectedTime === `${appointmentItem.id} ${item.startTime}`) {
                setSelectedTime({appointmentItem: {}});
              } else {
                let apItem = {...appointmentItem};
                apItem.appointmentSlots = [item];
                setSelectedTime({
                  key: `${appointmentItem.id} ${item.startTime}`,
                  appointmentItem: apItem,
                });
              }
            }}
            className={
              `${appointmentItem.id} ${item.startTime}` === selectedTime
                ? 'date-container-clicked'
                : 'date-container'
            }>
            <div
              style={{
                borderColor: buStyles.primaryColor,
                color: buStyles.primaryColor,
              }}
              className={
                `${appointmentItem.id} ${item.startTime}` === selectedTime
                  ? 'date-sub-container-clicked'
                  : 'date-sub-container'
              }>
              <span
                style={{
                  ...fonts.SM,
                  ...fonts.SemiBold,
                  color:
                    `${appointmentItem.id} ${item.startTime}` === selectedTime
                      ? colors.white
                      : buStyles.primaryColor,
                }}
                className="appointment-date-text">
                {moment(item.startTime).format('HH:mm')}
              </span>
            </div>
          </div>
        ))}
      </Row>
      <div className="reimbursement-history-declarationlist-line"></div>
      {appointmentClick && renderModalAndPopups()}
      {renderDoctorInfo()}
    </>
  );
}

const mapStateToProps = ({globalStyles, strings, language}: any) => ({
  buStyles: globalStyles.value,
  labels: strings.value.pt.appointments,
  language: language.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  addToWizard: (value: any) => dispatch(addToWizard(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(DoctorsListItemDayTime)
);
